export const teamDirectory = {
  contacts: [
    { name: 'DevOps Team Lead', role: 'Senior DevOps Engineer', email: 'devops-lead@company.com', slack: '@devops-lead' },
    { name: 'Infrastructure Architect', role: 'Cloud Architect', email: 'infra-arch@company.com', slack: '@infra-arch' },
    { name: 'Site Reliability Engineer', role: 'SRE Lead', email: 'sre-lead@company.com', slack: '@sre-lead' },
    { name: 'Security Engineer', role: 'DevSecOps', email: 'security@company.com', slack: '@security-team' }
  ],
  mentors: [
    { name: 'Senior DevOps Mentor', expertise: 'Infrastructure Automation & CI/CD', availability: 'Mon-Fri 2-4 PM' },
    { name: 'Cloud Mentor', expertise: 'AWS/Azure/GCP Architecture', availability: 'Tue/Thu 10 AM-12 PM' },
    { name: 'SRE Mentor', expertise: 'System Reliability & Monitoring', availability: 'Wed/Fri 3-5 PM' }
  ],
  collaborators: [
    { team: 'Development Teams', contact: 'dev-leads@company.com', purpose: 'CI/CD Pipeline Integration' },
    { team: 'Security Team', contact: 'security@company.com', purpose: 'Infrastructure Security' },
    { team: 'Product Team', contact: 'product@company.com', purpose: 'Release Planning' },
    { team: 'QA Team', contact: 'qa-lead@company.com', purpose: 'Test Environment Management' }
  ],
  channels: {
    primary: '#devops-team',
    announcements: '#devops-announcements',
    help: '#devops-help',
    infrastructure: '#infrastructure',
    monitoring: '#monitoring-alerts',
    incidents: '#incident-response',
    releases: '#release-coordination'
  }
};
